import { render, staticRenderFns } from "./TheUpsertWeightEstimation.vue?vue&type=template&id=fd72cc9c"
import script from "./TheUpsertWeightEstimation.vue?vue&type=script&lang=ts"
export * from "./TheUpsertWeightEstimation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports